import { Controller } from "@hotwired/stimulus"

// Off-canvas admin sidebar toggle (hamburger button in the topbar opens it,
// backdrop click / X button / Escape close it). Scoped on Admin::ShellComponent's
// root element so it can coordinate the sidebar panel and topbar button, which
// are rendered as sibling components. No-op above `lg`, where the sidebar is
// always visible via CSS (see sidebar_component.html.erb).
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open() {
    this.panelTarget.classList.remove("translate-x-full")
    this.backdropTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.panelTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    if (this.panelTarget.classList.contains("translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
